import useUserProfileStore from "zustandStores/userProfileStore";
import { SALES_CONTACT_NO } from "../services/constants";

export const getSalesContactNumber = () => {
  const profileData = useUserProfileStore.getState().profileData;
  return profileData?.sales_agent_contact_number || SALES_CONTACT_NO;
};
